<template>
  <div class="pdf-generator">
    <div class="pdf-left">
      <div class="left-header">
        <div class="header-left">
          <el-link href="https://www.wearehpr.cn/" target="_blank" :underline="false">杭漂人网络科技有限公司</el-link>
        </div>
        <div class="header-right">
          <el-dropdown @command="SaveLookHandle" style="margin-right:10px;">
            <el-button type="info" size="small">
              保存并浏览<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">无现状分析</el-dropdown-item>
              <el-dropdown-item command="b">有现状分析</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown @command="DownloadHandle" style="margin-right:10px;">
            <el-button size="small">
              下载PDF<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">无现状分析</el-dropdown-item>
              <el-dropdown-item command="b">有现状分析</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="left-container">
        <div class="report">
          <div class="report-title">基本信息</div>
          <div class="Basic-information">
            <div class="form-row">
              <div class="form-group">
                <span class="form-label">姓名：</span>
                <el-input size="small" placeholder="请输入候选人姓名" v-model="name" clearable>
                </el-input>
              </div>
              <div class="form-group">
                <span class="form-label">婚姻：</span>
                <el-select size="small" v-model="marriage" clearable placeholder="请选择婚姻状况">
                  <el-option v-for="item in marriageList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="form-group">
                <span class="form-label">现居：</span>
                <el-cascader size="small" placeholder="请选择现居地址" v-model="currentCity" :options="hjCityList"
                  :show-all-levels="true" filterable></el-cascader>
              </div>
              <div class="form-group">
                <span class="form-label">户籍：</span>
                <el-cascader size="small" placeholder="请选择户籍地址" v-model="hjCity" :options="hjCityList"
                  :show-all-levels="true" filterable></el-cascader>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <span class="form-label">推荐职位：</span>
                <el-input size="small" placeholder="请输入推荐职位" v-model="jobName" clearable>
                </el-input>
              </div>
              <div class="form-group">
                <span class="form-label">人选性别：</span>
                <div class="radio">
                  <el-radio v-model="gender" label="男">男</el-radio>
                  <el-radio v-model="gender" label="女">女</el-radio>
                </div>
              </div>
              <div class="form-group">
                <span class="form-label">出生日期：</span>
                <el-date-picker size="small" v-model="birthYear" type="year" placeholder="选择年份" format="yyyy 年"
                  @change="YearDateChange">
                </el-date-picker>
              </div>
              <div class="form-group">
                <span class="form-label">工作年限：</span>
                <el-select size="small" v-model="workYear" clearable placeholder="请选择">
                  <el-option v-for="item in workYearList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div class="report">
          <div class="report-title">现状分析</div>
          <div class="Situation-analysis">
            <div class="des-input">
              <span>目前：</span>
              <el-input size="small" placeholder="请输入人选目前薪资" v-model="currentSalary" clearable>
              </el-input>
              <div class="Salary-status">
                <el-radio v-model="salaryType" label="税前">税前</el-radio>
                <el-radio v-model="salaryType" label="税后">税后</el-radio>
              </div>
            </div>
            <div class="des-input">
              <span>期望：</span>
              <el-input size="small" placeholder="请输入人选期望薪资" v-model="desireSalary" clearable
                :disabled="salaryNegotiable" @change="desireMethod(desireSalary)">
              </el-input>
              <div class="Salary-status">
                <el-checkbox v-model="salaryNegotiable" @change="salaryMethod(salaryNegotiable)">面议</el-checkbox>
              </div>
            </div>
            <div class="interview">
              <div class="des-input">
                <span>到岗：</span>
                <el-input size="small" placeholder="请输入到岗时间" v-model="dutyTime" clearable>
                </el-input>
              </div>
              <div class="des-input">
                <span>面试：</span>
                <el-input size="small" placeholder="请输入面试时间" v-model="interviewTime" clearable>
                </el-input>
              </div>
            </div>
            <div class="Salary-structure">
              <span>薪资结构：</span>
              <el-input size="small" placeholder="请输入人选薪资结构" v-model="salaryStructure" clearable>
              </el-input>
            </div>
            <div class="Core-advantages">
              <div class="AIInfo" style="margin-bottom:10px;">
                <span>核心优势：</span>
              </div>
              <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 12 }" placeholder="请输入人选核心优势"
                v-model="coreStrengths">
              </el-input>
            </div>
            <div class="Core-advantages">
              <span>家庭情况：</span>
              <el-input size="small" placeholder="请输入人选家庭情况" v-model="familySituation" clearable>
              </el-input>
            </div>
            <div class="Core-advantages">
              <span>职位意向：</span>
              <el-input size="small" placeholder="请输入人选职位意向" v-model="jobIntention" clearable>
              </el-input>
            </div>
          </div>
        </div>
        <div class="report">
          <div class="report-title education-title">
            <div>教育经历</div>
            <div class="add-education">
              <i class="el-icon-circle-plus" @click="addEducation"> 添加教育经历</i>
            </div>
          </div>
          <div class="Education-experience" v-for="(item, i) in educationList" :key="i">
            <div class="Education-des">
              <div class="des-input">
                <span>学校：</span>
                <el-input size="small" placeholder="请输入学校名称" v-model="item.graduationSchool" clearable>
                </el-input>
              </div>
              <div class="des-input" style="margin-left: 20px;">
                <span>日期：</span>
                <div class="Education-date">
                  <div class="Education-date-des" style="border: 1px solid #DCDFE6;border-radius: 4px;width:210px;">
                    <el-date-picker size="small" v-model="item.schoolStart" type="month" placeholder="开始年月"
                      @change="changeEdu(i, 'Strat')">
                    </el-date-picker>
                    <i>至</i>
                    <el-date-picker size="small" v-model="item.schoolEnd" type="month" placeholder="结束年月"
                      :disabled="item.schoolEndNegotiable" @change="changeEdu(i, 'End')">
                    </el-date-picker>
                  </div>
                  <el-checkbox v-model="item.schoolEndNegotiable" style="margin-left: 20px;"
                    @change="setZJ(i, 'education')">至今</el-checkbox>
                </div>
              </div>
            </div>
            <div class="Education-des">
              <div class="des-input">
                <span>学历：</span>
                <el-select size="small" v-model="item.degree" clearable placeholder="请选择学历">
                  <el-option v-for="item in edus" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <div style="margin-left:20px">
                  <el-radio v-model="item.nationalUnified" label="统招">统招</el-radio>
                  <el-radio v-model="item.nationalUnified" label="非统招">非统招</el-radio>
                </div>
              </div>
            </div>
            <div class="Education-des">
              <div class="des-input">
                <span>专业：</span>
                <el-input size="small" placeholder="请输入专业名称" v-model="item.professional" clearable>
                </el-input>
                <el-tooltip class="item" effect="dark" content="删除教育经历" placement="top">
                  <i class="el-icon-delete" style="margin-left:20px;cursor: pointer;" @click="DelEdu(i)"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div class="report">
          <div class="report-title work-title">
            <div>工作经历</div>
            <div class="add-job">
              <i class="el-icon-circle-plus" @click="addWork"> 添加工作经历</i>
            </div>
          </div>
          <div class="Work-experience" v-for="(item, i) in workList" :key="i">
            <div class="Work-des">
              <div class="des-input">
                <span>日期：</span>
                <div class="Work-date">
                  <div class="Work-date-des" style="border: 1px solid #DCDFE6;border-radius: 4px;width:210px;">
                    <el-date-picker size="small" v-model="item.workStart" type="month" placeholder="开始年月"
                      @change="changeWork(i, 'Strat')">
                    </el-date-picker>
                    <i>至</i>
                    <el-date-picker size="small" v-model="item.workEnd" type="month" placeholder="结束年月"
                      :disabled="item.workEndNegotiable" @change="changeWork(i, 'End')">
                    </el-date-picker>
                  </div>
                  <el-checkbox v-model="item.workEndNegotiable" style="margin-left: 20px;"
                    @change="setZJ(i, 'work')">至今</el-checkbox>

                </div>
                <el-tooltip class="item" effect="dark" content="删除工作经历" placement="top">
                  <i class="el-icon-delete" style="margin-left:30px;cursor: pointer;" @click="DelWork(i)"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="Work-des">
              <div class="Work-des-content">
                <div class="des-input">
                  <span>公司：</span>
                  <el-input size="small" placeholder="请输入公司名称" v-model="item.companyName" clearable>
                  </el-input>
                </div>
                <div class="des-input">
                  <span>职位：</span>
                  <el-input size="small" placeholder="请输入任职职位" v-model="item.jobName" clearable>
                  </el-input>
                </div>
              </div>
            </div>
            <div class="Work-vertical">
              <span>工作关系：</span>
              <div class="des-input">
                <el-input size="small" placeholder="所在部门" v-model="item.department" clearable>
                </el-input>
                <el-input size="small" placeholder="汇报对象" v-model="item.report" clearable>
                </el-input>
                <el-input size="small" placeholder="管理人数" v-model="item.people" clearable>
                </el-input>
              </div>
            </div>
            <div class="Work-vertical">
              <span>工作职责：</span>
              <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 12 }" placeholder="请输入工作职责"
                v-model="item.workContent">
              </el-input>
            </div>
            <div class="Work-vertical">
              <span>工作业绩：</span>
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 12 }" placeholder="请输入工作业绩"
                v-model="item.workAchievement">
              </el-input>
            </div>
            <div class="Work-vertical" v-if="item.workEnd == '9999.0' || item.workEnd == '至今'">
              <span>求职动机：</span>
              <el-input size="small" type="textarea" :autosize="{ minRows: 1, maxRows: 1 }" placeholder="请输入求职动机"
                v-model="item.dimissionReason">
              </el-input>
            </div>
            <div class="Work-vertical" v-else>
              <span>离职原因：</span>
              <el-input size="small" type="textarea" :autosize="{ minRows: 1, maxRows: 1 }" placeholder="请输入离职原因"
                v-model="item.dimissionReason">
              </el-input>
            </div>
          </div>
        </div>
        <div class="report">
          <div class="report-title project-title">
            <div>项目经历</div>
            <div class="add-project">
              <i class="el-icon-circle-plus" @click="addProject"> 添加项目经历</i>
            </div>
          </div>
          <div class="project-experience" v-for="(item, i) in projectList" :key="i">
            <div class="project-des">
              <div class="des-input">
                <span>日期：</span>
                <div class="project-date">
                  <div class="project-date-des" style="border: 1px solid #DCDFE6;border-radius: 4px;width:210px;">
                    <el-date-picker size="small" v-model="item.projectStart" type="month" placeholder="开始年月"
                      @change="changeProject(i, 'Strat')">
                    </el-date-picker>
                    <i>至</i>
                    <el-date-picker size="small" v-model="item.projectEnd" type="month" placeholder="结束年月"
                      :disabled="item.projectEndNegotiable" @change="changeProject(i, 'End')">
                    </el-date-picker>
                  </div>
                  <el-checkbox v-model="item.projectEndNegotiable" style="margin-left: 20px;"
                    @change="setZJ(i, 'project')">至今</el-checkbox>
                </div>
                <el-tooltip class="item" effect="dark" content="删除项目经历" placement="top">
                  <i class="el-icon-delete" style="margin-left:30px;cursor: pointer;" @click="DelPro(i)"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="project-des">
              <div class="project-des-content">
                <div class="des-input">
                  <span style="margin-right:10px">项目名称：</span>
                  <el-input size="small" placeholder="请输入项目名称" v-model="item.projectName" clearable>
                  </el-input>
                </div>
              </div>
            </div>
            <div class="project-vertical">
              <span>项目描述：</span>
              <el-input size="small" type="textarea" :autosize="{ minRows: 5, maxRows: 12 }" placeholder="请输入项目描述"
                v-model="item.projectDesc">
              </el-input>
            </div>
            <div class="project-vertical">
              <span>项目职责：</span>
              <el-input size="small" type="textarea" :autosize="{ minRows: 4, maxRows: 12 }" placeholder="请输入项目职责"
                v-model="item.projectResponsibility">
              </el-input>
            </div>
            <div class="project-vertical">
              <span>项目业绩：</span>
              <el-input size="small" type="textarea" :autosize="{ minRows: 4, maxRows: 12 }" placeholder="请输入项目业绩"
                v-model="item.projectPerformance">
              </el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pdf-right">
      <!-- PDF预览区域 -->
      <div class="pdf-preview-container">
        <div class="pdf-preview" v-if="pages.length > 0">
          <!-- 动态生成的PDF页面 -->
          <div v-for="(page, pageIndex) in pages" :key="pageIndex" class="pdf-page" :ref="`page_${pageIndex}`">
            <!-- 页眉 -->
            <div class="pdf-header">
              <div class="header-left"><img src="@/assets/logo.png" width="100" height="40" alt=""></div>
              <div class="header-right">杭漂人网络科技有限公司</div>
            </div>

            <!-- 内容区域 -->
            <div class="pdf-content">
              <div v-for="(block, blockIndex) in page.blocks" :key="blockIndex" :class="['content-block', block.type]"
                :ref="`block_${pageIndex}_${blockIndex}`">
                <!-- 标题类型内容 -->
                <template v-if="block.type === 'heading'">
                  <div class="heading">{{ block.content }}</div>
                </template>
                <template v-if="block.type === 'date'">
                  <div class="date">{{ block.content }}</div>
                </template>
                <template v-if="block.type === 'name'">
                  <div class="name">
                    <div class="name-text">{{ block.content }}</div>
                    <div class="name-job">{{ block.jobName }}</div>
                  </div>
                </template>
                <template v-if="block.type === 'eduHead'">
                  <div class="eduTitle">
                    <div class="edu-title">{{ block.content }}</div>
                    <div class="edu-date">{{ block.date }}</div>
                  </div>
                </template>
                <template v-if="block.type === 'eduDesc'">
                  <div class="eduDesc">
                    <div class="edu-desc-text">{{ block.content }}</div>
                    <div class="edu-desc-major">{{ block.major }}</div>
                  </div>
                </template>
                <template v-if="block.type === 'workHead'">
                  <div class="workHead">
                    <div class="work-title">
                      <span class="text">{{ block.workDate }}</span>
                      <span class="text">{{ block.workName }}</span>
                      <span>{{ block.jobName }}</span>
                    </div>
                  </div>
                </template>
                <template v-if="block.type === 'workRela'">
                  <div class="workRela">
                    <div class="rela-title">
                      工作关系：
                    </div>
                    <div class="rela-desc">
                      <span class="text">所属部门：{{ block.depart }}</span>
                      <span class="text">汇报对象：{{ block.report }}</span>
                      <span>下属人数：{{ block.people }}</span>
                    </div>
                  </div>
                </template>
                <template v-if="block.type === 'workResp'">
                  <div class="workResp">
                    <div class="title">工作职责：</div>
                    <div v-for="(line, index) in block.workResp.split('\n')" :key="index" class="resp-text">
                      {{ line }}
                    </div>
                  </div>
                </template>
                <template v-if="block.type === 'workPerf'">
                  <div class="workPerf">
                    <div class="title">工作业绩：</div>
                    <div v-html="block.workPerf.replace(/\n/g, '<br>')"></div>
                  </div>
                </template>
                <template v-if="block.type === 'workDimiss'">
                  <div class="workDimiss">
                    <div class="title">离职原因：</div>
                    <div v-html="block.workDimiss.replace(/\n/g, '<br>')"></div>
                  </div>
                </template>
                <template v-if="block.type === 'projHead'">
                  <div class="projHead">
                    <div class="proj-title">
                      <span class="text">{{ block.projDate }}</span>
                      <span class="text">{{ block.projName }}</span>
                    </div>
                  </div>
                </template>
                <template v-if="block.type === 'projDesc'">
                  <div class="projDesc">
                    <div class="title">项目描述：</div>
                    <div v-html="block.projDesc.replace(/\n/g, '<br>')"></div>
                  </div>
                </template>
                <template v-if="block.type === 'projResp'">
                  <div class="projResp">
                    <div class="title">项目职责：</div>
                    <div v-html="block.projResp.replace(/\n/g, '<br>')"></div>
                  </div>
                </template>
                <template v-if="block.type === 'projPerf'">
                  <div class="projPerf">
                    <div class="title">项目业绩：</div>
                    <div v-html="block.projPerf.replace(/\n/g, '<br>')"></div>
                  </div>
                </template>
                <!-- 文本类型内容 -->
                <template v-if="block.type === 'text'">
                  <p>{{ block.content }}</p>
                </template>

                <!-- 图片类型内容 -->
                <template v-if="block.type === 'image'">
                  <div class="image-wrapper">
                    <img :src="block.src" :alt="block.alt" class="content-image">
                    <p class="image-caption" v-if="block.caption">{{ block.caption }}</p>
                  </div>
                </template>
                <!-- 表格类型内容 -->
                <template v-if="block.type === 'table'">
                  <table class="custom-table">
                    <thead>
                      <tr>
                        <th colspan="4" class="table-header">—— 现 状 分 析 ——</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="table-title">目前薪资</td>
                        <td class="table-desc">{{ block.curSalary }}</td>
                        <td class="table-title">期望薪资</td>
                        <td class="table-desc">{{ block.expSalary }}</td>
                      </tr>
                      <tr>
                        <td class="table-title">到岗时间</td>
                        <td class="table-desc">{{ block.onBoardTime }}</td>
                        <td class="table-title">面试时间</td>
                        <td class="table-desc">{{ block.interviewTime }}</td>
                      </tr>
                      <tr>
                        <td class="table-title">薪资结构</td>
                        <td colspan="3">{{ block.salaryStructure }}</td>
                      </tr>
                      <tr>
                        <td class="table-title">核心优势</td>
                        <td colspan="3" v-html="block.advantage.replace(/\n/g, '<br>')"></td>
                      </tr>
                      <tr>
                        <td class="table-title">家庭情况</td>
                        <td colspan="3">{{ block.family }}</td>
                      </tr>
                      <tr>
                        <td class="table-title">职位意向</td>
                        <td colspan="3">{{ block.position }}</td>
                      </tr>
                    </tbody>
                  </table>
                </template>
                <template v-if="block.type === 'exper'">
                  <div class="exper-box">
                    <div class="exper-title">
                      <span class="title-text">{{ block.content }}</span>
                      <span class="en-text">{{ block.english }}</span>
                    </div>
                    <div class="line"></div>
                  </div>
                </template>
              </div>
            </div>
            <!-- 页脚 -->
            <div class="pdf-footer">
              <div class="footer-left">公司机密文档 · 请勿外传</div>
              <div class="footer-center">{{ pageIndex + 1 }} / {{ pages.length }}</div>
              <div class="footer-right">www.wearehpr.cn</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { GetResumeInfo } from '@/request/api'
export default {
  data() {
    return {
      jobsDesc: '',
      isLoading: false,
      look: false,
      customerID: '', // 客户ID
      jobID: '', // 职位ID
      resumeID: '', // 简历ID
      customerName: '', // 客户公司名
      jobName: '', // 推荐职位
      currentDate: '', // 推荐日期
      name: '', //候选人姓名
      gender: '', //性别
      marriage: '', //婚姻状况
      marriageNew: '',
      currentCity: '',
      currentNewCity: '',
      hjCity: '',
      hjNewCity: '',
      hjCityList: [
        {
          label: '北京',
          value: '北京'
        },
        {
          label: '上海',
          value: '上海'
        },
        {
          label: '天津',
          value: '天津'
        },
        {
          label: '重庆',
          value: '重庆'
        },
        {
          value: '安徽',
          label: '安徽',
          children: [
            {
              label: '安庆',
              value: '安庆'
            },
            {
              label: '蚌埠',
              value: '蚌埠'
            },
            {
              label: '毫州',
              value: '毫州'
            },
            {
              label: '池州',
              value: '池州'
            },
            {
              label: '滁州',
              value: '滁州'
            },
            {
              label: '阜阳',
              value: '阜阳'
            },
            {
              label: '合肥',
              value: '合肥'
            },
            {
              label: '淮北',
              value: '淮北'
            },
            {
              label: '淮南',
              value: '淮南'
            },
            {
              label: '黄山',
              value: '黄山'
            },
            {
              label: '六安',
              value: '六安'
            },
            {
              label: '马鞍山',
              value: '马鞍山'
            },
            {
              label: '宿州',
              value: '宿州'
            },
            {
              label: '铜陵',
              value: '铜陵'
            },
            {
              label: '芜湖',
              value: '芜湖'
            },
            {
              label: '宣城',
              value: '宣城'
            }
          ]
        },
        {
          value: '河北',
          label: '河北',
          children: [
            {
              label: '石家庄',
              value: '石家庄'
            },
            {
              label: '保定',
              value: '保定'
            },
            {
              label: '张家口',
              value: '张家口'
            },
            {
              label: '承德',
              value: '承德'
            },
            {
              label: '沧州',
              value: '沧州'
            },
            {
              label: '唐山',
              value: '唐山'
            },
            {
              label: '廊坊',
              value: '廊坊'
            },
            {
              label: '衡水',
              value: '衡水'
            },
            {
              label: '秦皇岛',
              value: '秦皇岛'
            },
            {
              label: '邯郸',
              value: '邯郸'
            },
            {
              label: '邢台',
              value: '邢台'
            }
          ]
        },
        {
          value: '山西',
          label: '山西',
          children: [
            {
              label: '太原',
              value: '太原'
            },
            {
              label: '阳泉',
              value: '阳泉'
            },
            {
              label: '长治',
              value: '长治'
            },
            {
              label: '晋城',
              value: '晋城'
            },
            {
              label: '朔州',
              value: '朔州'
            },
            {
              label: '晋中',
              value: '晋中'
            },
            {
              label: '运城',
              value: '运城'
            },
            {
              label: '忻州',
              value: '忻州'
            },
            {
              label: '临汾',
              value: '临汾'
            },
            {
              label: '吕梁',
              value: '吕梁'
            },
            {
              label: '大同',
              value: '大同'
            }
          ]
        },
        {
          value: '辽宁',
          label: '辽宁',
          children: [
            {
              label: '大连',
              value: '大连'
            },
            {
              label: '沈阳',
              value: '沈阳'
            },
            {
              label: '抚顺',
              value: '抚顺'
            },
            {
              label: '本溪',
              value: '本溪'
            },
            {
              label: '丹东',
              value: '丹东'
            },
            {
              label: '锦州',
              value: '锦州'
            },
            {
              label: '营口',
              value: '营口'
            },
            {
              label: '阜新',
              value: '阜新'
            },
            {
              label: '辽阳',
              value: '辽阳'
            },
            {
              label: '盘锦',
              value: '盘锦'
            },
            {
              label: '铁岭',
              value: '铁岭'
            },
            {
              label: '朝阳',
              value: '朝阳'
            },
            {
              label: '葫芦岛',
              value: '葫芦岛'
            },
            {
              label: '鞍山',
              value: '鞍山'
            }
          ]
        },
        {
          value: '吉林',
          label: '吉林',
          children: [
            {
              label: '长春',
              value: '长春'
            },
            {
              label: '白山',
              value: '白山'
            },
            {
              label: '松原',
              value: '松原'
            },
            {
              label: '白城',
              value: '白城'
            },
            {
              label: '延边',
              value: '延边'
            },
            {
              label: '吉林市',
              value: '吉林市'
            },
            {
              label: '四平',
              value: '四平'
            },
            {
              label: '辽源',
              value: '辽源'
            },
            {
              label: '通化',
              value: '通化'
            }
          ]
        },
        {
          value: '黑龙江',
          label: '黑龙江',
          children: [
            {
              label: '哈尔滨',
              value: '哈尔滨'
            },
            {
              label: '佳木斯',
              value: '佳木斯'
            },
            {
              label: '七台河',
              value: '七台河'
            },
            {
              label: '牡丹江',
              value: '牡丹江'
            },
            {
              label: '黑河',
              value: '黑河'
            },
            {
              label: '绥化',
              value: '绥化'
            },
            {
              label: '大兴安岭',
              value: '大兴安岭'
            },
            {
              label: '齐齐哈尔',
              value: '齐齐哈尔'
            },
            {
              label: '鸡西',
              value: '鸡西'
            },
            {
              label: '鹤岗',
              value: '鹤岗'
            },
            {
              label: '双鸭山',
              value: '双鸭山'
            },
            {
              label: '大庆',
              value: '大庆'
            },
            {
              label: '伊春',
              value: '伊春'
            }
          ]
        },
        {
          value: '江苏',
          label: '江苏',
          children: [
            {
              label: '苏州',
              value: '苏州'
            },
            {
              label: '南京',
              value: '南京'
            },
            {
              label: '淮安',
              value: '淮安'
            },
            {
              label: '盐城',
              value: '盐城'
            },
            {
              label: '扬州',
              value: '扬州'
            },
            {
              label: '镇江',
              value: '镇江'
            },
            {
              label: '泰州',
              value: '泰州'
            },
            {
              label: '宿迁',
              value: '宿迁'
            },
            {
              label: '无锡',
              value: '无锡'
            },
            {
              label: '徐州',
              value: '徐州'
            },
            {
              label: '常州',
              value: '常州'
            },
            {
              label: '南通',
              value: '南通'
            },
            {
              label: '连云港',
              value: '连云港'
            }
          ]
        },
        {
          value: '浙江',
          label: '浙江',
          children: [
            {
              label: '杭州',
              value: '杭州'
            },
            {
              label: '台州',
              value: '台州'
            },
            {
              label: '丽水',
              value: '丽水'
            },
            {
              label: '宁波',
              value: '宁波'
            },
            {
              label: '温州',
              value: '温州'
            },
            {
              label: '嘉兴',
              value: '嘉兴'
            },
            {
              label: '湖州',
              value: '湖州'
            },
            {
              label: '绍兴',
              value: '绍兴'
            },
            {
              label: '金华',
              value: '金华'
            },
            {
              label: '衢州',
              value: '衢州'
            },
            {
              label: '舟山',
              value: '舟山'
            }
          ]
        },
        {
          value: '福建',
          label: '福建',
          children: [
            {
              label: '福州',
              value: '福州'
            },
            {
              label: '厦门',
              value: '厦门'
            },
            {
              label: '莆田',
              value: '莆田'
            },
            {
              label: '三明',
              value: '三明'
            },
            {
              label: '泉州',
              value: '泉州'
            },
            {
              label: '漳州',
              value: '漳州'
            },
            {
              label: '南平',
              value: '南平'
            },
            {
              label: '龙岩',
              value: '龙岩'
            },
            {
              label: '宁德',
              value: '宁德'
            }
          ]
        },
        {
          value: '江西',
          label: '江西',
          children: [
            {
              label: '南昌',
              value: '南昌'
            },
            {
              label: '萍乡',
              value: '萍乡'
            },
            {
              label: '九江',
              value: '九江'
            },
            {
              label: '新余',
              value: '新余'
            },
            {
              label: '鹰潭',
              value: '鹰潭'
            },
            {
              label: '赣州',
              value: '赣州'
            },
            {
              label: '吉安',
              value: '吉安'
            },
            {
              label: '宜春',
              value: '宜春'
            },
            {
              label: '抚州',
              value: '抚州'
            },
            {
              label: '上饶',
              value: '上饶'
            },
            {
              label: '景德镇',
              value: '景德镇'
            }
          ]
        },
        {
          value: '山东',
          label: '山东',
          children: [
            {
              label: '济南',
              value: '济南'
            },
            {
              label: '枣庄',
              value: '枣庄'
            },
            {
              label: '东营',
              value: '东营'
            },
            {
              label: '烟台',
              value: '烟台'
            },
            {
              label: '潍坊',
              value: '潍坊'
            },
            {
              label: '济宁',
              value: '济宁'
            },
            {
              label: '泰安',
              value: '泰安'
            },
            {
              label: '威海',
              value: '威海'
            },
            {
              label: '日照',
              value: '日照'
            },
            {
              label: '临沂',
              value: '临沂'
            },
            {
              label: '德州',
              value: '德州'
            },
            {
              label: '聊城',
              value: '聊城'
            },
            {
              label: '滨州',
              value: '滨州'
            },
            {
              label: '青岛',
              value: '青岛'
            },
            {
              label: '菏泽',
              value: '菏泽'
            },
            {
              label: '淄博',
              value: '淄博'
            }
          ]
        },
        {
          value: '河南',
          label: '河南',
          children: [
            {
              label: '郑州',
              value: '郑州'
            },
            {
              label: '商丘',
              value: '商丘'
            },
            {
              label: '开封',
              value: '开封'
            },
            {
              label: '信阳',
              value: '信阳'
            },
            {
              label: '洛阳',
              value: '洛阳'
            },
            {
              label: '周口',
              value: '周口'
            },
            {
              label: '驻马店',
              value: '驻马店'
            },
            {
              label: '平顶山',
              value: '平顶山'
            },
            {
              label: '济源',
              value: '济源'
            },
            {
              label: '安阳',
              value: '安阳'
            },
            {
              label: '鹤壁',
              value: '鹤壁'
            },
            {
              label: '新乡',
              value: '新乡'
            },
            {
              label: '焦作',
              value: '焦作'
            },
            {
              label: '濮阳',
              value: '濮阳'
            },
            {
              label: '许昌',
              value: '许昌'
            },
            {
              label: '漯河',
              value: '漯河'
            },
            {
              label: '三门峡',
              value: '三门峡'
            },
            {
              label: '南阳',
              value: '南阳'
            }
          ]
        },
        {
          value: '湖北',
          label: '湖北',
          children: [
            {
              label: '武汉',
              value: '武汉'
            },
            {
              label: '黄冈',
              value: '黄冈'
            },
            {
              label: '咸宁',
              value: '咸宁'
            },
            {
              label: '随州',
              value: '随州'
            },
            {
              label: '恩施州',
              value: '恩施州'
            },
            {
              label: '仙桃',
              value: '仙桃'
            },
            {
              label: '潜江',
              value: '潜江'
            },
            {
              label: '天门',
              value: '天门'
            },
            {
              label: '神农架',
              value: '神农架'
            },
            {
              label: '黄石',
              value: '黄石'
            },
            {
              label: '十堰',
              value: '十堰'
            },
            {
              label: '宜昌',
              value: '宜昌'
            },
            {
              label: '襄阳',
              value: '襄阳'
            },
            {
              label: '鄂州',
              value: '鄂州'
            },
            {
              label: '荆门',
              value: '荆门'
            },
            {
              label: '孝感',
              value: '孝感'
            },
            {
              label: '荆州',
              value: '荆州'
            }
          ]
        },
        {
          value: '湖南',
          label: '湖南',
          children: [
            {
              label: '长沙',
              value: '长沙'
            },
            {
              label: '永州',
              value: '永州'
            },
            {
              label: '怀化',
              value: '怀化'
            },
            {
              label: '娄底',
              value: '娄底'
            },
            {
              label: '湘西',
              value: '湘西'
            },
            {
              label: '株洲',
              value: '株洲'
            },
            {
              label: '湘潭',
              value: '湘潭'
            },
            {
              label: '衡阳',
              value: '衡阳'
            },
            {
              label: '邵阳',
              value: '邵阳'
            },
            {
              label: '岳阳',
              value: '岳阳'
            },
            {
              label: '常德',
              value: '常德'
            },
            {
              label: '张家界',
              value: '张家界'
            },
            {
              label: '益阳',
              value: '益阳'
            },
            {
              label: '郴州',
              value: '郴州'
            }
          ]
        },
        {
          value: '广东',
          label: '广东',
          children: [
            {
              label: '广州',
              value: '广州'
            },
            {
              label: '深圳',
              value: '深圳'
            },
            {
              label: '惠州',
              value: '惠州'
            },
            {
              label: '梅州',
              value: '梅州'
            },
            {
              label: '汕尾',
              value: '汕尾'
            },
            {
              label: '河源',
              value: '河源'
            },
            {
              label: '阳江',
              value: '阳江'
            },
            {
              label: '清远',
              value: '清远'
            },
            {
              label: '东莞',
              value: '东莞'
            },
            {
              label: '韶关',
              value: '韶关'
            },
            {
              label: '中山',
              value: '中山'
            },
            {
              label: '珠海',
              value: '珠海'
            },
            {
              label: '潮州',
              value: '潮州'
            },
            {
              label: '揭阳',
              value: '揭阳'
            },
            {
              label: '汕头',
              value: '汕头'
            },
            {
              label: '云浮',
              value: '云浮'
            },
            {
              label: '佛山',
              value: '佛山'
            },
            {
              label: '江门',
              value: '江门'
            },
            {
              label: '湛江',
              value: '湛江'
            },
            {
              label: '茂名',
              value: '茂名'
            },
            {
              label: '肇庆',
              value: '肇庆'
            }
          ]
        },
        {
          value: '广西',
          label: '广西',
          children: [
            {
              label: '梧州',
              value: '梧州'
            },
            {
              label: '北海',
              value: '北海'
            },
            {
              label: '防城港',
              value: '防城港'
            },
            {
              label: '钦州',
              value: '钦州'
            },
            {
              label: '贵港',
              value: '贵港'
            },
            {
              label: '玉林',
              value: '玉林'
            },
            {
              label: '百色',
              value: '百色'
            },
            {
              label: '贺州',
              value: '贺州'
            },
            {
              label: '河池',
              value: '河池'
            },
            {
              label: '来宾',
              value: '来宾'
            },
            {
              label: '崇左',
              value: '崇左'
            },
            {
              label: '南宁',
              value: '南宁'
            },
            {
              label: '柳州',
              value: '柳州'
            },
            {
              label: '桂林',
              value: '桂林'
            }
          ]
        },
        {
          value: '海南',
          label: '海南',
          children: [
            {
              label: '海口',
              value: '海口'
            },
            {
              label: '三亚',
              value: '三亚'
            },
            {
              label: '三沙',
              value: '三沙'
            },
            {
              label: '儋州',
              value: '儋州'
            },
            {
              label: '五指山',
              value: '五指山'
            },
            {
              label: '琼海',
              value: '琼海'
            },
            {
              label: '文昌',
              value: '文昌'
            },
            {
              label: '万宁',
              value: '万宁'
            },
            {
              label: '东方',
              value: '东方'
            },
            {
              label: '定安县',
              value: '定安县'
            },
            {
              label: '屯昌县',
              value: '屯昌县'
            },
            {
              label: '澄迈县',
              value: '澄迈县'
            },
            {
              label: '临高县',
              value: '临高县'
            },
            {
              label: '白沙县',
              value: '白沙县'
            },
            {
              label: '昌江县',
              value: '昌江县'
            },
            {
              label: '乐东县',
              value: '乐东县'
            },
            {
              label: '陵水县',
              value: '陵水县'
            },
            {
              label: '保亭县',
              value: '保亭县'
            },
            {
              label: '琼中县',
              value: '琼中县'
            }
          ]
        },
        {
          value: '四川',
          label: '四川',
          children: [
            {
              label: '成都',
              value: '成都'
            },
            {
              label: '南充',
              value: '南充'
            },
            {
              label: '眉山',
              value: '眉山'
            },
            {
              label: '宜宾',
              value: '宜宾'
            },
            {
              label: '广安',
              value: '广安'
            },
            {
              label: '达州',
              value: '达州'
            },
            {
              label: '雅安',
              value: '雅安'
            },
            {
              label: '巴中',
              value: '巴中'
            },
            {
              label: '自贡',
              value: '自贡'
            },
            {
              label: '资阳',
              value: '资阳'
            },
            {
              label: '阿坝',
              value: '阿坝'
            },
            {
              label: '攀枝花',
              value: '攀枝花'
            },
            {
              label: '泸州',
              value: '泸州'
            },
            {
              label: '甘孜',
              value: '甘孜'
            },
            {
              label: '德阳',
              value: '德阳'
            },
            {
              label: '绵阳',
              value: '绵阳'
            },
            {
              label: '凉山',
              value: '凉山'
            },
            {
              label: '广元',
              value: '广元'
            },
            {
              label: '遂宁',
              value: '遂宁'
            },
            {
              label: '内江',
              value: '内江'
            },
            {
              label: '乐山',
              value: '乐山'
            }
          ]
        },
        {
          value: '贵州',
          label: '贵州',
          children: [
            {
              label: '贵阳',
              value: '贵阳'
            },
            {
              label: '遵义',
              value: '遵义'
            },
            {
              label: '安顺',
              value: '安顺'
            },
            {
              label: '毕节',
              value: '毕节'
            },
            {
              label: '铜仁',
              value: '铜仁'
            },
            {
              label: '黔西南',
              value: '黔西南'
            },
            {
              label: '黔东南',
              value: '黔东南'
            },
            {
              label: '黔南',
              value: '黔南'
            },
            {
              label: '六盘水',
              value: '六盘水'
            }
          ]
        },
        {
          value: '云南',
          label: '云南',
          children: [
            {
              label: '昆明',
              value: '昆明'
            },
            {
              label: '丽江',
              value: '丽江'
            },
            {
              label: '普洱',
              value: '普洱'
            },
            {
              label: '临沧',
              value: '临沧'
            },
            {
              label: '楚雄州',
              value: '楚雄州'
            },
            {
              label: '红河',
              value: '红河'
            },
            {
              label: '文山州',
              value: '文山州'
            },
            {
              label: '西双版纳',
              value: '西双版纳'
            },
            {
              label: '大理州',
              value: '大理州'
            },
            {
              label: '德宏',
              value: '德宏'
            },
            {
              label: '怒江',
              value: '怒江'
            },
            {
              label: '迪庆',
              value: '迪庆'
            },
            {
              label: '曲靖',
              value: '曲靖'
            },
            {
              label: '玉溪',
              value: '玉溪'
            },
            {
              label: '保山',
              value: '保山'
            },
            {
              label: '昭通',
              value: '昭通'
            }
          ]
        },
        {
          value: '陕西',
          label: '陕西',
          children: [
            {
              label: '西安',
              value: '西安'
            },
            {
              label: '汉中',
              value: '汉中'
            },
            {
              label: '榆林',
              value: '榆林'
            },
            {
              label: '安康',
              value: '安康'
            },
            {
              label: '商洛',
              value: '商洛'
            },
            {
              label: '杨陵',
              value: '杨陵'
            },
            {
              label: '铜川',
              value: '铜川'
            },
            {
              label: '宝鸡',
              value: '宝鸡'
            },
            {
              label: '咸阳',
              value: '咸阳'
            },
            {
              label: '渭南',
              value: '渭南'
            },
            {
              label: '延安',
              value: '延安'
            }
          ]
        },
        {
          value: '甘肃',
          label: '甘肃',
          children: [
            {
              label: '兰州',
              value: '兰州'
            },
            {
              label: '临夏',
              value: '临夏'
            },
            {
              label: '甘南',
              value: '甘南'
            },
            {
              label: '嘉峪关',
              value: '嘉峪关'
            },
            {
              label: '金昌',
              value: '金昌'
            },
            {
              label: '白银',
              value: '白银'
            },
            {
              label: '天水',
              value: '天水'
            },
            {
              label: '武威',
              value: '武威'
            },
            {
              label: '张掖',
              value: '张掖'
            },
            {
              label: '平凉',
              value: '平凉'
            },
            {
              label: '酒泉',
              value: '酒泉'
            },
            {
              label: '庆阳',
              value: '庆阳'
            },
            {
              label: '定西',
              value: '定西'
            },
            {
              label: '陇南',
              value: '陇南'
            }
          ]
        },
        {
          value: '青海',
          label: '青海',
          children: [
            {
              label: '西宁',
              value: '西宁'
            },
            {
              label: '海东',
              value: '海东'
            },
            {
              label: '海北',
              value: '海北'
            },
            {
              label: '黄南',
              value: '黄南'
            },
            {
              label: '海南州',
              value: '海南州'
            },
            {
              label: '果洛',
              value: '果洛'
            },
            {
              label: '玉树',
              value: '玉树'
            },
            {
              label: '海西',
              value: '海西'
            }
          ]
        },
        {
          value: '宁夏',
          label: '宁夏',
          children: [
            {
              label: '银川',
              value: '银川'
            },
            {
              label: '石嘴山',
              value: '石嘴山'
            },
            {
              label: '吴忠',
              value: '吴忠'
            },
            {
              label: '固原',
              value: '固原'
            },
            {
              label: '中卫',
              value: '中卫'
            }
          ]
        },
        {
          value: '新疆',
          label: '新疆',
          children: [
            {
              label: '博尔塔拉',
              value: '博尔塔拉'
            },
            {
              label: '巴音郭楞',
              value: '巴音郭楞'
            },
            {
              label: '阿克苏',
              value: '阿克苏'
            },
            {
              label: '克州',
              value: '克州'
            },
            {
              label: '喀什',
              value: '喀什'
            },
            {
              label: '和田',
              value: '和田'
            },
            {
              label: '伊犁',
              value: '伊犁'
            },
            {
              label: '塔城',
              value: '塔城'
            },
            {
              label: '阿勒泰',
              value: '阿勒泰'
            },
            {
              label: '石河子',
              value: '石河子'
            },
            {
              label: '阿拉尔',
              value: '阿拉尔'
            },
            {
              label: '图木舒克',
              value: '图木舒克'
            },
            {
              label: '五家渠',
              value: '五家渠'
            },
            {
              label: '北屯',
              value: '北屯'
            },
            {
              label: '铁门关',
              value: '铁门关'
            },
            {
              label: '双河',
              value: '双河'
            },
            {
              label: '可克达拉',
              value: '可克达拉'
            },
            {
              label: '昆玉',
              value: '昆玉'
            },
            {
              label: '乌鲁木齐',
              value: '乌鲁木齐'
            },
            {
              label: '克拉玛依',
              value: '克拉玛依'
            },
            {
              label: '吐鲁番',
              value: '吐鲁番'
            },
            {
              label: '哈密',
              value: '哈密'
            },
            {
              label: '昌吉',
              value: '昌吉'
            }
          ]
        },
        {
          value: '内蒙古',
          label: '内蒙古',
          children: [
            {
              label: '乌海',
              value: '乌海'
            },
            {
              label: '赤峰',
              value: '赤峰'
            },
            {
              label: '通辽',
              value: '通辽'
            },
            {
              label: '鄂尔多斯',
              value: '鄂尔多斯'
            },
            {
              label: '呼伦贝尔',
              value: '呼伦贝尔'
            },
            {
              label: '巴彦淖尔',
              value: '巴彦淖尔'
            },
            {
              label: '乌兰察布',
              value: '乌兰察布'
            },
            {
              label: '兴安盟',
              value: '兴安盟'
            },
            {
              label: '锡盟',
              value: '锡盟'
            },
            {
              label: '阿拉善盟',
              value: '阿拉善盟'
            },
            {
              label: '呼和浩特',
              value: '呼和浩特'
            },
            {
              label: '包头',
              value: '包头'
            }
          ]
        }
      ],
      marriageList: [
        {
          value: '1',
          label: '未婚'
        },
        {
          value: '2',
          label: '已婚未育'
        },
        {
          value: '3',
          label: '已婚已育'
        },
        {
          value: '4',
          label: '离异'
        }
      ], //婚姻列表数据
      workYearList: [
        { label: '1年', value: '1' },
        { label: '2年', value: '2' },
        { label: '3年', value: '3' },
        { label: '4年', value: '4' },
        { label: '5年', value: '5' },
        { label: '6年', value: '6' },
        { label: '7年', value: '7' },
        { label: '8年', value: '8' },
        { label: '9年', value: '9' },
        { label: '10年', value: '10' },
        { label: '11年', value: '11' },
        { label: '12年', value: '12' },
        { label: '13年', value: '13' },
        { label: '14年', value: '14' },
        { label: '14年以上', value: '15' }
      ],
      birthYear: '', //生日年份
      birthYearNew: '',
      workYear: '', //工作经验
      workYearNew: '',
      currentSalary: '', //目前薪资
      salaryType: '', //薪资类型
      desireSalary: '', //期望薪资
      desireSalary2: '', //期望薪资
      salaryNegotiable: false, //薪资面议
      dutyTime: '', //到岗时间
      dutytimeList: [
        { label: '离职，随时到岗', value: '离职，随时到岗' },
        { label: '在职，月内到岗', value: '在职，月内到岗' },
        { label: '在职，考虑机会', value: '在职，考虑机会' },
        { label: '在职，暂不考虑', value: '在职，暂不考虑' }
      ], //到岗时间列表
      interviewTime: '近期都方便', //面试时间
      salaryStructure: '底薪(80%)+绩效(20%)+年终奖，五险一金全额缴纳', //薪资结构
      coreStrengths: '', //核心优势
      familySituation: '候选人已婚已育，现居杭州彭埠，户籍，对地点可以接受。', //家庭情况
      jobIntention: '人选对职位的规划意向度高，愿意进一步接触，目前刚离职。', //职位意向
      educationNew: [],
      educationList: [],
      workListNew: [],
      workList: [],
      projectListNew: [],
      projectList: [],
      edus: [
        {
          value: '1',
          label: '大专以下'
        },
        {
          value: '2',
          label: '大专'
        },
        {
          value: '3',
          label: '本科'
        },
        {
          value: '4',
          label: '硕士'
        },
        {
          value: '5',
          label: '博士'
        },
        {
          value: '6',
          label: 'MBA/EMBA'
        }
      ],
      eduNew: '',
      // 页面数据
      pages: [],
      // PDF配置
      pdfConfig: {
        format: 'a4',
        orientation: 'portrait',
        unit: 'mm',
        margin: { top: 20, right: 20, bottom: 20, left: 20 }
      },
      // 生成状态
      isGenerating: false
    };
  },
  watch: {
    currentCity(newVal, oldVal) {
      if (newVal === '') {
        this.currentNewCity = ''
      } else {
        this.currentNewCity = '｜现居' + newVal
      }
    },
    hjCity(newVal, oldVal) {
      if (newVal === '') {
        this.hjNewCity = ''
      } else {
        this.hjNewCity = '｜户籍' + newVal
      }
    },
    birthYear(newVal, oldVal) {
      const nowYear = new Date()
      this.birthYearNew = nowYear.getFullYear() - newVal + '岁(' + newVal + ')'
    },
    marriage(newVal, oldVal) {
      if (newVal === '') {
        this.marriageNew = ''
      } else if (newVal === '1') {
        this.marriageNew = '｜未婚'
      } else if (newVal === '2') {
        this.marriageNew = '｜已婚未育'
      } else if (newVal === '3') {
        this.marriageNew = '｜已婚已育'
      } else if (newVal === '4') {
        this.marriageNew = '｜离异'
      }
    },
    workYear(newVal, oldVal) {
      if (newVal === '1') {
        this.workYearNew = '1年经验'
      } else if (newVal === '2') {
        this.workYearNew = '2年经验'
      } else if (newVal === '3') {
        this.workYearNew = '3年经验'
      } else if (newVal === '4') {
        this.workYearNew = '4年经验'
      } else if (newVal === '5') {
        this.workYearNew = '5年经验'
      } else if (newVal === '6') {
        this.workYearNew = '6年经验'
      } else if (newVal === '7') {
        this.workYearNew = '7年经验'
      } else if (newVal === '8') {
        this.workYearNew = '8年经验'
      } else if (newVal === '9') {
        this.workYearNew = '9年经验'
      } else if (newVal === '10') {
        this.workYearNew = '10年经验'
      } else if (newVal === '11') {
        this.workYearNew = '11年经验'
      } else if (newVal === '12') {
        this.workYearNew = '12年经验'
      } else if (newVal === '13') {
        this.workYearNew = '13年经验'
      } else if (newVal === '14') {
        this.workYearNew = '14年经验'
      } else if (newVal >= '15') {
        this.workYearNew = '14年以上经验'
      } else {
        this.workYearNew = '1年以下经验'
      }
    }
  },
  methods: {
    // 将数据封装成pages格式
    generatePagesData(isShow) {
      // 1. 准备基础数据（保持原有的逻辑不变）
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      this.currentDate = `${year}-${month}-${day}`;

      const blocks = [];
      // 添加标题和基本信息（这部分保持不变）
      if (isShow) {
        blocks.push(
          { type: 'heading', content: '候选人推荐报告' },
          { type: 'date', content: `(${this.currentDate})` },
          { type: 'name', content: this.name, jobName: `(推荐职位：${this.jobName})` },
          { type: 'text', content: `${this.gender}｜${this.birthYearNew}${this.marriageNew}｜${this.workYearNew}${this.currentNewCity}${this.hjNewCity}` },
          { type: 'table', curSalary: `${this.currentSalary}(${this.salaryType})`, expSalary: `${this.desireSalary2}`, onBoardTime: `${this.dutyTime}`, interviewTime: `${this.interviewTime}`, salaryStructure: `${this.salaryStructure}`, advantage: `${this.coreStrengths}`, family: `${this.familySituation}`, position: `${this.jobIntention}` },
        );
      } else {
        blocks.push(
          { type: 'heading', content: '候选人推荐报告' },
          { type: 'date', content: `(${this.currentDate})` },
          { type: 'name', content: this.name, jobName: `(推荐职位：${this.jobName})` },
          { type: 'text', content: `${this.gender}｜${this.birthYearNew}${this.marriageNew}｜${this.workYearNew}${this.currentNewCity}${this.hjNewCity}` },
        );
      }
      // 添加教育经历
      if (this.educationList && this.educationList.length > 0) {
        // 添加教育经历标题
        blocks.push({ type: 'exper', content: '教育经历', english: 'Education' });
        // 遍历教育经历列表
        this.educationList.forEach(item => {
          // 处理学历显示
          let degreeText = '';
          switch (item.degree) {
            case '1': degreeText = '大专以下'; break;
            case '2': degreeText = '大专'; break;
            case '3': degreeText = '本科'; break;
            case '4': degreeText = '硕士'; break;
            case '5': degreeText = '博士'; break;
            case '6': degreeText = 'MBA/EMBA'; break;
            default: degreeText = item.degree;
          }

          // 处理时间显示
          const startDate = item.schoolStart ? item.schoolStart.replace('-', '.') : '';
          const endDate = item.schoolEndNegotiable || item.schoolEnd === '9999.0' ? '至今' : (item.schoolEnd ? item.schoolEnd.replace('-', '.') : '');

          // 添加教育经历块
          blocks.push(
            {
              type: 'eduHead',
              content: item.graduationSchool,
              date: `${startDate} - ${endDate}`
            },
            {
              type: 'eduDesc',
              content: `${degreeText}｜${item.nationalUnified}`,
              major: item.professional
            }
          );
        });
      }

      // 添加工作经历
      if (this.workList && this.workList.length > 0) {
        // 添加工作经历标题
        blocks.push({ type: 'exper', content: '工作经历', english: 'Work Experience' });
        // 遍历工作经历列表
        this.workList.forEach(item => {
          // 处理时间显示
          const startDate = item.workStart ? item.workStart.replace('-', '.') : '';
          const endDate = item.workEndNegotiable || item.workEnd === '9999.0' ? '至今' : (item.workEnd ? item.workEnd.replace('-', '.') : '');

          // 添加工作经历块
          blocks.push(
            {
              type: 'workHead',
              workDate: `${startDate} - ${endDate}`,
              workName: item.companyName,
              jobName: item.jobName
            },
          );
          if (item.department || item.report || item.people) {
            blocks.push({
              type: 'workRela',
              depart: item.department,
              report: item.report,
              people: item.people
            });
          }
          // 只有当工作职责不为空时才添加
          if (item.workContent) {
            blocks.push({
              type: 'workResp',
              workResp: item.workContent
            });
          }

          // 只有当工作业绩不为空时才添加
          if (item.workAchievement) {
            blocks.push({
              type: 'workPerf',
              workPerf: item.workAchievement
            });
          }
          // 如果有离职/求职原因，则添加
          if (item.dimission) {
            blocks.push({
              type: 'workDimiss',
              workDimiss: item.dimission
            });
          }
        });
      }

      // 添加项目经历
      if (this.projectList && this.projectList.length > 0) {
        // 添加项目经历标题
        blocks.push({ type: 'exper', content: '项目经历', english: 'Project Experience' });

        // 遍历项目经历列表
        this.projectList.forEach(item => {
          // 处理时间显示
          const startDate = item.projectStart ? item.projectStart.replace('-', '.') : '';
          const endDate = item.projectEndNegotiable || item.projectEnd === '9999.0' ? '至今' : (item.projectEnd ? item.projectEnd.replace('-', '.') : '');

          // 添加项目经历块
          blocks.push(
            {
              type: 'projHead',
              projDate: `${startDate} - ${endDate}`,
              projName: item.projectName
            },
            {
              type: 'projDesc',
              projDesc: item.projectDesc || ''
            }
          );
          if (item.projectResponsibility) {
            blocks.push({
              type: 'projResp',
              projResp: item.projectResponsibility || ''
            });
          }
          if (item.projectPerformance) {
            blocks.push({
              type: 'projPerf',
              projPerf: item.projectPerformance || ''
            });
          }
        });
      }
      // 2. 关键修改：重置页面数组，先放入所有内容到第一页
      // 必须使用 blocks 数组，哪怕它很长
      this.pages = [{ blocks: blocks }];

      // 3. 触发分页计算，但要延时执行，确保 Vue 先把第一页渲染出来
      this.$nextTick(() => {
        setTimeout(() => {
          this.checkAndAdjustPagination();
        }, 100); // 100ms 延时确保 DOM 挂载
      });
    },
    // 生成PDF
    generatePagesData(isShow) {
      // 1. 基础信息设置
      const today = new Date();
      this.currentDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

      const allBlocks = []; // 用于存放所有内容块的大数组

      // 2. 组装数据 (这是你原有的逻辑，保持不变，确保数据完整)
      // --- 头部信息 ---
      if (isShow) {
        allBlocks.push(
          { type: 'heading', content: '候选人推荐报告' },
          { type: 'date', content: `(${this.currentDate})` },
          { type: 'name', content: this.name, jobName: `(推荐职位：${this.jobName})` },
          { type: 'text', content: `${this.gender}｜${this.birthYearNew}${this.marriageNew}｜${this.workYearNew}${this.currentNewCity}${this.hjNewCity}` },
          { type: 'table', curSalary: `${this.currentSalary}(${this.salaryType})`, expSalary: `${this.desireSalary2}`, onBoardTime: `${this.dutyTime}`, interviewTime: `${this.interviewTime}`, salaryStructure: `${this.salaryStructure}`, advantage: `${this.coreStrengths}`, family: `${this.familySituation}`, position: `${this.jobIntention}` }
        );
      } else {
        allBlocks.push(
          { type: 'heading', content: '候选人推荐报告' },
          { type: 'date', content: `(${this.currentDate})` },
          { type: 'name', content: this.name, jobName: `(推荐职位：${this.jobName})` },
          { type: 'text', content: `${this.gender}｜${this.birthYearNew}${this.marriageNew}｜${this.workYearNew}${this.currentNewCity}${this.hjNewCity}` }
        );
      }

      // --- 教育经历 ---
      if (this.educationList && this.educationList.length > 0) {
        allBlocks.push({ type: 'exper', content: '教育经历', english: 'Education' });
        this.educationList.forEach(item => {
          let degreeText = item.degree;
          // ... (此处保留你原有的 switch case degreeText 逻辑) ...
          switch (item.degree) {
            case '1': degreeText = '大专以下'; break;
            case '2': degreeText = '大专'; break;
            case '3': degreeText = '本科'; break;
            case '4': degreeText = '硕士'; break;
            case '5': degreeText = '博士'; break;
            case '6': degreeText = 'MBA/EMBA'; break;
          }
          const startDate = item.schoolStart ? item.schoolStart.replace('-', '.') : '';
          const endDate = item.schoolEndNegotiable || item.schoolEnd === '9999.0' ? '至今' : (item.schoolEnd ? item.schoolEnd.replace('-', '.') : '');

          allBlocks.push(
            { type: 'eduHead', content: item.graduationSchool, date: `${startDate} - ${endDate}` },
            { type: 'eduDesc', content: `${degreeText}｜${item.nationalUnified}`, major: item.professional }
          );
        });
      }

      // --- 工作经历 ---
      if (this.workList && this.workList.length > 0) {
        allBlocks.push({ type: 'exper', content: '工作经历', english: 'Work Experience' });
        this.workList.forEach(item => {
          const startDate = item.workStart ? item.workStart.replace('-', '.') : '';
          const endDate = item.workEndNegotiable || item.workEnd === '9999.0' ? '至今' : (item.workEnd ? item.workEnd.replace('-', '.') : '');

          allBlocks.push({ type: 'workHead', workDate: `${startDate} - ${endDate}`, workName: item.companyName, jobName: item.jobName });

          if (item.department || item.report || item.people) {
            allBlocks.push({ type: 'workRela', depart: item.department, report: item.report, people: item.people });
          }
          if (item.workContent) allBlocks.push({ type: 'workResp', workResp: item.workContent });
          if (item.workAchievement) allBlocks.push({ type: 'workPerf', workPerf: item.workAchievement });
          if (item.dimission) allBlocks.push({ type: 'workDimiss', workDimiss: item.dimission });
        });
      }

      // --- 项目经历 ---
      if (this.projectList && this.projectList.length > 0) {
        allBlocks.push({ type: 'exper', content: '项目经历', english: 'Project Experience' });
        this.projectList.forEach(item => {
          const startDate = item.projectStart ? item.projectStart.replace('-', '.') : '';
          const endDate = item.projectEndNegotiable || item.projectEnd === '9999.0' ? '至今' : (item.projectEnd ? item.projectEnd.replace('-', '.') : '');

          allBlocks.push(
            { type: 'projHead', projDate: `${startDate} - ${endDate}`, projName: item.projectName },
            { type: 'projDesc', projDesc: item.projectDesc || '' }
          );
          if (item.projectResponsibility) allBlocks.push({ type: 'projResp', projResp: item.projectResponsibility || '' });
          if (item.projectPerformance) allBlocks.push({ type: 'projPerf', projPerf: item.projectPerformance || '' });
        });
      }

      // 3. 关键步骤：先全部放入第一页，不直接分页
      this.pages = [{ blocks: allBlocks }];

      // 4. 开始计算布局 (一定要延时，等待 Vue 渲染出那个超级长的第一页)
      this.$nextTick(() => {
        setTimeout(() => {
          this.checkAndAdjustPagination();
        }, 300); // 300ms 确保 DOM 完全出来
      });
    },
    // 检查并调整分页
    async checkAndAdjustPagination() {
      // 1. 获取第一页的 DOM (此时包含了所有内容)
      const pageRef = this.$refs['page_0'];
      if (!pageRef || !pageRef[0]) return;

      const contentElement = pageRef[0].querySelector('.pdf-content');
      if (!contentElement) return;

      const blockElements = contentElement.querySelectorAll('.content-block');
      if (blockElements.length === 0) return;

      // 2. 准备新数据的容器
      const newPages = []; // 存放最终页面的数组
      let currentBlockList = []; // 当前页正在收集的 blocks
      let currentHeight = 0; // 当前页累积高度

      // 3. 设定阈值 (A4 内容区安全高度，建议 900-920px)
      const MAX_HEIGHT = 900;

      // 4. 遍历所有 DOM 元素，获取真实高度
      for (let i = 0; i < blockElements.length; i++) {
        const domEl = blockElements[i];

        // 获取包含 margin 的完整高度
        const style = window.getComputedStyle(domEl);
        const h = domEl.offsetHeight + parseFloat(style.marginTop) + parseFloat(style.marginBottom);

        // 对应的原始数据 (this.pages[0].blocks 是源数据)
        const blockData = this.pages[0].blocks[i];

        // 5. 判断是否溢出
        if (currentHeight + h > MAX_HEIGHT) {
          // 如果当前块放进去会溢出：
          // a. 把之前收集好的块打成一页，存入 newPages
          if (currentBlockList.length > 0) {
            newPages.push({ blocks: currentBlockList });
          }

          // b. 开启新的一页，当前块作为新页的第一个块
          currentBlockList = [blockData];
          currentHeight = h; // 重置高度为当前块高度
        } else {
          // 没溢出，加入当前页
          currentBlockList.push(blockData);
          currentHeight += h;
        }
      }

      // 6. 循环结束后，把最后一页剩下的内容放进去
      if (currentBlockList.length > 0) {
        newPages.push({ blocks: currentBlockList });
      }

      // 7. 最终赋值：一次性更新视图
      console.log(`分页完成，共拆分为 ${newPages.length} 页`);
      this.pages = newPages;

      // 强制刷新一下防止视图没跟上
      this.$forceUpdate();
    },
    // 查找溢出的内容块
    findOverflowBlocks(pageIndex, maxHeight) {
      // 安全获取页面元素
      const pageRef = this.$refs[`page_${pageIndex}`];
      if (!pageRef || !pageRef[0]) {
        return { lastBlockIndex: -1, remainingHeight: 0 };
      }

      const pageElement = pageRef[0];
      const contentElement = pageElement.querySelector('.pdf-content');
      if (!contentElement) {
        return { lastBlockIndex: -1, remainingHeight: 0 };
      }

      // 获取所有内容块
      const blocks = Array.from(contentElement.querySelectorAll('.content-block'));

      // 逐个显示块并计算累积高度
      let currentHeight = 0;
      let lastBlockIndex = -1;

      for (let i = 0; i < blocks.length; i++) {
        // 获取当前块的高度
        const computedStyle = window.getComputedStyle(blocks[i]);
        const marginTop = parseFloat(computedStyle.marginTop) || 0;
        const marginBottom = parseFloat(computedStyle.marginBottom) || 0;
        const blockHeight = blocks[i].offsetHeight + marginTop + marginBottom;
        const newHeight = currentHeight + blockHeight;

        // 如果加上当前块后会超出页面高度，则停止
        if (newHeight > maxHeight) {
          break;
        }

        currentHeight = newHeight;
        lastBlockIndex = i;
      }

      return {
        lastBlockIndex,
        remainingHeight: maxHeight - currentHeight
      };
    },
    SaveLookHandle(command) {
      if (command === 'a') {
        this.generatePagesData(false)
      } else {
        this.generatePagesData(true)
      }
    },
    DownloadHandle(command) {
      if (!this.jobName) {
        this.$message.warning('推荐职位名称不能为空！');
        return;
      }
      if (command === 'a') {
        this.generatePdf(false)
      } else {
        if (!this.currentSalary || !this.salaryType || !this.desireSalary2 || !this.dutyTime || !this.interviewTime || !this.salaryStructure || !this.coreStrengths || !this.familySituation || !this.jobIntention) {
          this.$message.warning('现状分析信息不能为空！');
          return;
        }
        this.generatePdf(true)
      }
    },
    async resumeInfo(resumeID) {
      const { data: res } = await GetResumeInfo({ ID: resumeID, timestamp: Date.now(), username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, isShare: JSON.parse(sessionStorage.getItem('LoginInfo')).shareResume });
      if (res.code !== 200) return this.$message.error(res.message);
      this.name = res.data.resumeInfo.name;
      this.gender = res.data.resumeInfo.gender === 1 ? '男' : '女';
      this.birthYear = res.data.resumeInfo.birthDate;
      const nowYear = new Date();
      this.workYear = nowYear.getFullYear() - res.data.resumeInfo.workYear;
      if (this.workYear >= 15) {
        this.workYear = '15';
      } else {
        this.workYear = (nowYear.getFullYear() - res.data.resumeInfo.workYear).toString();
      }
      if (res.data.eduInfo !== undefined) {
        res.data.eduInfo.forEach(item => {
          var EndNegotiable = false
          if (item.endTime === '9999.0') {
            EndNegotiable = true
          }
          this.educationList.push({
            schoolEndNegotiable: EndNegotiable,
            graduationSchool: item.eduName,
            schoolStart: item.startTime,
            schoolEnd: item.endTime,
            degree: item.degree,
            nationalUnified: item.nationalUnified === 1 ? '统招' : '非统招',
            professional: item.professional
          })
        })
      }
      if (res.data.workInfo !== undefined) {
        res.data.workInfo.forEach(item => {
          var EndNegotiable = false
          if (item.endTime === '9999.0') {
            EndNegotiable = true
          }
          if (item.workAchievement === '9999') {
            item.workAchievement = ''
          } else {
            item.workAchievement = item.workAchievement.replace(/<br\/>/g, '\n')
          }

          if (item.dimission === '9999') {
            item.dimission = ''
          } else {
            item.dimission = item.dimission.replace(/<br\/>/g, '\n')
          }

          if (item.workContent === '9999') {
            item.workContent = ''
          } else {
            item.workContent = item.workContent.replace(/<br\/>/g, '\n')
          }
          this.workList.push({
            workStart: item.startTime,
            workEnd: item.endTime,
            workEndNegotiable: EndNegotiable,
            companyName: item.companyName,
            jobName: item.jobName,
            department: item.department,
            report: item.report,
            people: item.people,
            workContent: item.workContent,
            workAchievement: item.workAchievement,
            dimission: item.dimission
          })
        })
      }
      if (res.data.projectInfo !== undefined) {
        res.data.projectInfo.forEach(item => {
          var EndNegotiable = false
          if (item.endTime === '9999.0') {
            EndNegotiable = true
          }
          if (item.projectDesc === '9999') {
            item.projectDesc = ''
          } else {
            item.projectDesc = item.projectDesc.replace(/<br\/>/g, '\n')
          }

          if (item.projectPerformance === '9999') {
            item.projectPerformance = ''
          } else {
            item.projectPerformance = item.projectPerformance.replace(/<br\/>/g, '\n')
          }

          if (item.projectResponsibility === '9999') {
            item.projectResponsibility = ''
          } else {
            item.projectResponsibility = item.projectResponsibility.replace(/<br\/>/g, '\n')
          }
          this.projectList.push({
            projectStart: item.startTime,
            projectEnd: item.endTime,
            projectEndNegotiable: EndNegotiable,
            projectName: item.projectName,
            projectDesc: item.projectDesc,
            projectResponsibility: item.projectResponsibility,
            projectPerformance: item.projectPerformance
          })
        })
      }
    },
    salaryMethod(isfalse) {
      if (isfalse === true) {
        this.desireSalary2 = '面议'
      }
    },
    desireMethod(value) {
      this.desireSalary2 = value
    },
    YearDateChange(value) {
      const date = new Date(value)
      const nowYear = new Date()
      const age = nowYear.getFullYear() - date.getFullYear()
      this.birthYearNew = age + '岁(' + date.getFullYear() + ')'
    },
    DelEdu(index) {
      this.educationList.splice(index, 1)
    },
    DelWork(index) {
      this.workList.splice(index, 1)
    },
    DelPro(index) {
      this.projectList.splice(index, 1)
    },
    addProject() {
      this.projectList.push([
        {
          projectStart: '2019-06',
          projectEnd: '2021-01',
          projectEndNegotiable: false,
          projectName: '悦萱堂BD',
          projectDesc: 'BD化妆品公司，与悦萱堂签约猎头合同，负责该公司所有的高端岗位的招聘。',
          projectResponsibility: '负责梳理岗位信息，明确人才画像，分配给团队伙伴操作岗位。',
          projectPerformance: '成功交付市场总监、培训总监。'
        }
      ])
    },
    addWork() {
      this.workList.push([
        {
          workStart: '2019-06',
          workEnd: '2021-03',
          workEndNegotiable: false,
          companyName: '杭州杭漂人网络科技有限公司',
          jobName: '董事长',
          companyDesc: '杭州杭漂人网络科技有限公司成立于2024年，公司主要从事高端人才猎取。',
          department: '总裁办',
          reportPeople: '无',
          underPeople: '3',
          workContent: '1.负责公司日常运营，客户签约谈判；\n2.负责团队搭建，新人带教；\n3.负责猎头人才库的搭建。',
          workAchievement: '无',
          dimissionReason: '看看新机会'
        }
      ])
    },
    addEducation() {
      this.educationList.push([
        {
          graduationSchool: '重庆城市职业学院',
          schoolStart: '2016-09',
          schoolEnd: '2019-06',
          schoolEndNegotiable: false,
          degree: '大专',
          nationalUnified: '统招',
          professional: '建设工程管理'
        }
      ])
    },
    setZJ(index, name) {
      if (name === 'project') {
        this.projectList[index].projectEnd = '9999.0'
      } else if (name === 'work') {
        this.workList[index].workEnd = '9999.0'
      } else if (name === 'education') {
        this.educationList[index].schoolEnd = '9999.0'
      }
    },
    changeEdu(i, name) {
      if (name === 'Strat') {
        const date = new Date(this.educationList[i].schoolStart)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        this.educationList[i].schoolStart = `${year}.${month}`
      } else {
        const date = new Date(this.educationList[i].schoolEnd)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        this.educationList[i].schoolEnd = `${year}.${month}`
      }
    },
    changeWork(i, name) {
      if (name === 'Strat') {
        const date = new Date(this.workList[i].workStart)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        this.workList[i].workStart = `${year}.${month}`
      } else {
        const date = new Date(this.workList[i].workEnd)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        this.workList[i].workEnd = `${year}.${month}`
      }
    },
    changeProject(i, name) {
      if (name === 'Strat') {
        const date = new Date(this.projectList[i].projectStart)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        this.projectList[i].projectStart = `${year}.${month}`
      } else {
        const date = new Date(this.projectList[i].projectEnd)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        this.projectList[i].projectEnd = `${year}.${month}`
      }
    },
    textBetween(str, left_key, right_key) {
      var g_left = str.indexOf(left_key)
      if (g_left != -1) {
        g_left = g_left + left_key.length
        var g_right = str.indexOf(right_key, g_left)
      }
      if (g_right != -1) {
        return str.substr(g_left, g_right - g_left)
      }
    },
  },
  created() {
    this.resumeID = this.textBetween(this.$route.fullPath, 'resumeID=', '&timestamp');
    this.resumeInfo(this.resumeID);
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

/* 样式保持不变 */
.pdf-generator {
  background-color: #f9f9f9;
  min-height: 100vh;
  font-family: 'Noto Sans', 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  display: flex;

  .pdf-left {
    width: 46%;
    height: 100%;

    .left-header {
      position: sticky;
      z-index: 100;
      top: 0;
      height: 50px;
      background-color: #e9ecf1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;

      .header-left {
        .el-link {
          font-size: 16px;
        }
      }

      .header-right {
        display: flex;
        align-items: center;
      }
    }

    .left-container {
      background-color: #fff;
      padding: 0 30px;
      height: calc(100% - 50px);
      overflow-y: auto;

      .report {
        padding-bottom: 30px;
        border-bottom: 1px solid #eaeaea;
        margin-bottom: 30px;

        .report-title {
          position: relative;
          color: #000;
          margin-top: 30px;
        }

        .education-title {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .add-education {
            color: #409eff;
            font-size: 14px;
            cursor: pointer;
          }
        }

        .work-title {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .add-job {
            color: #409eff;
            font-size: 14px;
            cursor: pointer;
          }
        }

        .project-title {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .add-project {
            color: #409eff;
            font-size: 14px;
            cursor: pointer;
          }
        }

        .report-title::before {
          position: absolute;
          content: ' ';
          left: -10px;
          width: 3px;
          height: 100%;
          background: #409eff;
        }

        .prompt {
          margin: 20px 0;
          text-align: center;
          letter-spacing: 2px;
        }

        .workProof {
          display: flex;
          margin-bottom: 20px;

          span {
            margin-bottom: 5px;
          }

          .des-input {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-left: 20px;
          }
        }

        .company {
          border-top: 1px dashed #dcdfe6;
          padding: 20px 0;
          position: relative;

          .des-input {
            .company-name::before {
              position: absolute;
              content: '*';
              left: 20px;
              width: 3px;
              height: 100%;
              color: red;
            }
          }
        }

        .el-divider {
          .is-center {
            color: #409eff;
            font-size: 18px;
            font-weight: bold;
            letter-spacing: 3px;
          }
        }

        .Basic-information {
          padding: 20px;
          border-radius: 4px;

          .form-row {
            display: flex;
            flex-wrap: wrap;
            margin: 0 -10px 15px;

          }

          .form-row:last-child {
            margin-bottom: 0;
          }

          .form-group {
            flex: 1;
            min-width: 300px;
            padding: 0 10px;
            margin-bottom: 15px;
            display: flex;
            align-items: center;
          }

          .form-label {
            width: 80px;
            text-align: right;
            margin-right: 15px;
            white-space: nowrap;
            font-weight: 500;
          }

          .form-group .el-input,
          .form-group .el-select,
          .form-group .el-cascader {
            flex: 1;
          }

          .radio-group {
            display: flex;
            align-items: center;
            gap: 15px;
          }

          .radio-group .el-radio {
            margin-right: 0;
          }
        }

        .Situation-analysis {
          display: flex;
          flex-direction: column;
          margin-top: 20px;

          .des-input {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .Salary-status {
              margin-left: 20px;
            }
          }

          .interview {
            display: flex;
            align-content: center;
            justify-content: space-between;

            .des-input {
              display: flex;
              align-content: center;

              .el-select {
                width: 210px;
              }

              .el-input {
                width: 210px;
              }
            }
          }

          .Salary-structure {
            display: flex;
            flex-direction: column;

            span {
              margin-bottom: 15px;
            }

            .el-input {
              width: 100%;
            }
          }

          .Core-advantages {
            display: flex;
            flex-direction: column;
            margin-top: 20px;

            span {
              margin-bottom: 15px;
            }

            .el-input {
              width: 100%;
            }
          }

          span {
            width: 66px;
            text-align: right;
            white-space: nowrap;
          }

          .el-input {
            width: 210px;
          }
        }

        .Education-experience:last-child {
          border-bottom: none;
          padding: 0;
        }

        .Education-experience {
          display: flex;
          flex-direction: column;
          border-bottom: 1px dashed #dcdfe6;
          padding: 10px 0 30px 0;

          .Education-des {
            display: flex;
            margin-top: 20px;

            .des-input {
              display: flex;
              align-items: center;

              .Education-date {
                display: flex;
                align-items: center;

                .Education-date-des {
                  display: flex;
                  align-items: center;

                  ::v-deep .el-date-editor {
                    width: 110px;

                    .el-input__prefix {
                      display: none;
                    }

                    .el-input__inner {
                      border: 0;
                      padding-left: 20px;
                      padding-right: 20px;
                    }
                  }
                }
              }

              .el-input,
              .el-select {
                width: 210px;
              }

              span {
                width: 66px;
                text-align: right;
                white-space: nowrap;
              }
            }
          }
        }

        .Work-experience:last-child {
          border-bottom: none;
          padding: 0;
        }

        .Work-experience {
          display: flex;
          flex-direction: column;
          border-bottom: 1px dashed #dcdfe6;
          padding: 10px 0 30px 0;
          border-bottom: 1px dashed #dcdfe6;

          .Work-vertical {
            display: flex;
            flex-direction: column;
            margin-top: 20px;

            .des-input {
              display: flex;

              .el-input {
                width: 130px;
                margin-right: 20px;
              }
            }

            span {
              width: 66px;
              text-align: left;
              white-space: nowrap;
              margin-bottom: 15px;
            }

            .el-input {
              width: 100%;
            }
          }

          .Work-des {
            display: flex;
            margin-top: 20px;

            .Work-des-content {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            }

            .des-input {
              display: flex;
              align-items: center;

              .el-input {
                width: 210px;
              }

              span {
                width: 66px;
                text-align: right;
                white-space: nowrap;
              }

              .Work-date {
                display: flex;
                align-items: center;

                .Work-date-des {
                  display: flex;
                  align-items: center;

                  ::v-deep .el-date-editor {
                    width: 110px;

                    .el-input__prefix {
                      display: none;
                    }

                    .el-input__inner {
                      border: 0;
                      padding-left: 20px;
                      padding-right: 20px;
                    }
                  }
                }
              }
            }
          }
        }

        .project-experience {
          display: flex;
          flex-direction: column;
          border-bottom: 1px dashed #dcdfe6;
          padding: 10px 0 30px 0;
          border-bottom: 1px dashed #dcdfe6;

          .project-vertical {
            display: flex;
            flex-direction: column;
            margin-top: 20px;

            .des-input {
              display: flex;

              .el-input {
                width: 130px;
                margin-right: 20px;
              }
            }

            span {
              width: 66px;
              text-align: left;
              white-space: nowrap;
              margin-bottom: 15px;
            }

            .el-input {
              width: 100%;
            }
          }

          .project-des {
            display: flex;
            margin-top: 20px;

            .project-des-content {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            }

            .des-input {
              display: flex;
              align-items: center;

              .el-input {
                width: 210px;
              }

              span {
                width: 66px;
                text-align: right;
                white-space: nowrap;
              }

              .project-date {
                display: flex;
                align-items: center;

                .project-date-des {
                  display: flex;
                  align-items: center;

                  ::v-deep .el-date-editor {
                    width: 110px;

                    .el-input__prefix {
                      display: none;
                    }

                    .el-input__inner {
                      border: 0;
                      padding-left: 20px;
                      padding-right: 20px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .pdf-right {
    flex: 1;
    width: 55%;
    height: 297mm;
    overflow-y: scroll;
    padding: 10px;

    .control-panel {
      margin-bottom: 30px;
      display: flex;
      gap: 15px;
      flex-wrap: wrap;
    }

    .btn {
      padding: 10px 20px;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      transition: all 0.3s ease;
    }

    .btn:disabled {
      opacity: 0.7;
      cursor: not-allowed;
      transform: none;
    }

    .generate-btn {
      background-color: #e53935;
      color: white;
    }

    .add-content-btn {
      background-color: #43a047;
      color: white;
    }

    .reset-btn {
      background-color: #2196f3;
      color: white;
    }

    .btn:hover:not(:disabled) {
      opacity: 0.9;
      transform: translateY(-2px);
    }

    .pdf-page {
      width: 210mm;
      height: 297mm;
      /* 固定高度 */
      background: white;
      margin: 0 auto 20px auto;
      padding: 15mm;
      /* 内边距 */
      box-sizing: border-box;
      overflow: hidden;
      /* 隐藏溢出，虽然我们逻辑上已经控制不溢出了 */
      position: relative;
      display: flex;
      flex-direction: column;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }

    .pdf-header {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 15mm;
      // border-bottom: 1px solid #e0e0e0;
      padding: 0 12mm;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 10pt;
    }

    .header-left,
    .header-right {
      color: #666;
    }

    .header-center {
      font-weight: bold;
      color: #333;
    }

    .pdf-content {
      width: 100%;
      flex: 1;
      /* 让内容区域自动撑满页眉页脚之外的空间 */
      overflow: hidden;
    }

    .content-block {
      width: 100%;
      margin-bottom: 10px;
      box-sizing: border-box;
      page-break-inside: avoid;
    }

    .content-block.heading h2 {
      font-size: 16pt;
      margin: 20px 0 15px;
      color: #2c3e50;
    }

    .content-block.heading h3 {
      font-size: 14pt;
      margin: 18px 0 12px;
      color: #34495e;
    }

    .image-wrapper {
      margin: 25px 0;
      text-align: center;
    }

    .content-image {
      max-width: 100%;
      height: auto;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .image-caption {
      margin-top: 8px;
      color: #666;
      font-size: 10pt;
      font-style: italic;
    }

    .exper-box {
      display: flex;

    }

    /* 标题样式 */
    .exper-title {
      position: relative;
      padding: 6px 45px 6px 15px;
      /* 给左侧形状留出空间 */
      color: #333;
      /* 文字颜色，可按需改 */
      background-color: #424345;
    }

    .exper-title::after {
      position: absolute;
      content: "";
      width: 5px;
      height: 100%;
      top: 0;
      right: -5px;
      background-color: #409ffd;
    }

    .title-text {
      font-size: 18px;
      color: white;
      letter-spacing: 2px;
    }

    .en-text {
      margin-left: 8px;
      font-size: 16px;
      color: #999;
    }

    .line {
      flex: 1;
      border-bottom: 3px dashed #424345;
    }

    // 推荐报告样式
    .heading {
      text-align: center;
      font-size: 28px;
      font-weight: bold;
      letter-spacing: 8px;
    }

    // 推荐日期样式
    .date {
      text-align: center;
      font-size: 20px;
      font-weight: bold;
    }

    // 推荐人跟职位样式
    .name {
      display: flex;
      align-items: center;

      .name-text {
        font-size: 22px;
        font-weight: bold;
        letter-spacing: 3px;
      }

      .name-job {
        margin-left: 25px;
        font-size: 16px;
      }
    }

    // 教育经历样式
    .eduTitle {
      display: flex;
      align-items: center;
      font-weight: bold;
      font-size: 16px;

      .edu-title {
        margin-right: 18px;
      }
    }

    .eduDesc {
      display: flex;
      align-items: center;
      font-size: 16px;
      margin-left: 6px;

      .edu-desc-text {
        margin-right: 18px;
      }
    }

    .eduTitle::before {
      content: "·";
      margin-right: 5px;
    }

    // 工作经历样式
    .workHead {
      font-size: 16px;

      .work-title {
        font-weight: bold;

        .text {
          margin-right: 15px;
        }
      }

      .work-title::before {
        content: "·";
        margin-right: 5px;
      }
    }

    .workRela {
      margin-left: 6px;

      .rela-title {
        font-weight: bold;
        margin: 8px 0;
      }

      .rela-desc {
        .text {
          margin-right: 60px;
        }
      }
    }

    .workResp,
    .workPerf,
    .workDimiss {
      margin-left: 6px;

      .title {
        font-weight: bold;
        margin: 8px 0;
      }

      .resp-text {
        line-height: 1.5;
        /* 设置行高 */
        margin-bottom: 2px;
        /* 设置段落间距 */
        white-space: pre-wrap;
        /* 保留文字内部的空格 */
        word-break: break-all;
        /* 防止长单词导致布局错乱 */
      }
    }


    // 项目经历样式
    .projHead {
      font-size: 16px;

      .proj-title {
        font-weight: bold;

        .text {
          margin-right: 15px;
        }
      }

      .proj-title::before {
        content: "·";
        margin-right: 5px;
      }
    }

    .projDesc,
    .projResp,
    .projPerf {
      margin-left: 6px;

      .title {
        font-weight: bold;
        margin: 8px 0;
      }

    }

    // 表格样式
    .custom-table {
      width: 100%;
      border-collapse: collapse;
      text-align: left;
    }

    .table-header {
      background-color: #0099ff;
      color: white;
      padding: 10px;
      text-align: center;
      font-weight: bold;
      font-size: 16px;
    }

    .custom-table td,
    .custom-table th {
      border: 1px solid #ccc;
      padding: 12px;
    }

    .table-title {
      width: 80px;
      vertical-align: middle;
      text-align: center;
      white-space: nowrap;
      font-weight: bold;
    }

    .table-desc {
      width: 150px;
      text-align: center;
      white-space: nowrap;
    }

    ul {
      margin: 0;
      padding-left: 20px;
    }

    .pdf-footer {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 12mm;
      // border-top: 1px solid #e0e0e0;
      padding: 0 12mm;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 10pt;
      color: #666;
    }

    .empty-state {
      text-align: center;
      padding: 50px;
      color: #666;
    }
  }
}
</style>